"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskDocumentStatus = exports.TaskStatus = exports.TaskRequirementType = exports.TaskType = void 0;
// === Task enums ===
// Determines what the user is asked to do
var TaskType;
(function (TaskType) {
    // Doc upload task types
    TaskType["UPLOAD_SUPPORTING_DOCUMENT"] = "UPLOAD_SUPPORTING_DOCUMENT";
    TaskType["UPLOAD_GOVERNMENT_IDENTIFICATION"] = "UPLOAD_GOVERNMENT_IDENTIFICATION";
    TaskType["UPLOAD_PAY_STUB"] = "UPLOAD_PAY_STUB";
    TaskType["UPLOAD_W2"] = "UPLOAD_W2";
    TaskType["UPLOAD_BANK_STATEMENT"] = "UPLOAD_BANK_STATEMENT";
    TaskType["UPLOAD_INVESTMENT_ACCOUNT_STATEMENT"] = "UPLOAD_INVESTMENT_ACCOUNT_STATEMENT";
    TaskType["UPLOAD_RETIREMENT_ACCOUNT_STATEMENT"] = "UPLOAD_RETIREMENT_ACCOUNT_STATEMENT";
    TaskType["UPLOAD_RETIREMENT_TERMS_AND_CONDITIONS_OF_WITHDRAWAL"] = "UPLOAD_RETIREMENT_TERMS_AND_CONDITIONS_OF_WITHDRAWAL";
    TaskType["UPLOAD_SOURCE_OF_FUNDS_FOR_LARGE_DEPOSIT"] = "UPLOAD_SOURCE_OF_FUNDS_FOR_LARGE_DEPOSIT";
    TaskType["UPLOAD_MORTGAGE_STATEMENT"] = "UPLOAD_MORTGAGE_STATEMENT";
    TaskType["UPLOAD_HOMEOWNERS_INSURANCE_POLICY"] = "UPLOAD_HOMEOWNERS_INSURANCE_POLICY";
    TaskType["UPLOAD_FLOOD_INSURANCE_POLICY"] = "UPLOAD_FLOOD_INSURANCE_POLICY";
    TaskType["UPLOAD_HOMEOWNERS_ASSOCIATION_STATEMENT"] = "UPLOAD_HOMEOWNERS_ASSOCIATION_STATEMENT";
    // Doc generation task types
    TaskType["UPLOAD_LETTER_OF_EXPLANATION_FOR_CREDIT_INQUIRIES"] = "UPLOAD_LETTER_OF_EXPLANATION_FOR_CREDIT_INQUIRIES";
    // Signing task types
    TaskType["SIGN_BORROWER_CLOSE_ACCOUNT_AUTHORIZATION"] = "SIGN_BORROWER_CLOSE_ACCOUNT_AUTHORIZATION";
})(TaskType || (exports.TaskType = TaskType = {}));
// Determines what is required to complete the task
var TaskRequirementType;
(function (TaskRequirementType) {
    TaskRequirementType["DOCUMENT_UPLOAD_REQUIRED"] = "DOCUMENT_UPLOAD_REQUIRED";
    TaskRequirementType["DOCUMENT_ACK_REQUIRED"] = "DOCUMENT_ACK_REQUIRED";
    TaskRequirementType["SIGNATURE_REQUIRED"] = "SIGNATURE_REQUIRED";
})(TaskRequirementType || (exports.TaskRequirementType = TaskRequirementType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["READY"] = "READY";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["ABANDONED"] = "ABANDONED";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
var TaskDocumentStatus;
(function (TaskDocumentStatus) {
    TaskDocumentStatus["WAITING_FOR_DOCUMENT"] = "WAITING_FOR_DOCUMENT";
    TaskDocumentStatus["IN_REVIEW"] = "IN_REVIEW";
    TaskDocumentStatus["DOCUMENT_ACCEPTED"] = "DOCUMENT_ACCEPTED";
    TaskDocumentStatus["RESUBMISSION_REQUIRED"] = "RESUBMISSION_REQUIRED";
    TaskDocumentStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(TaskDocumentStatus || (exports.TaskDocumentStatus = TaskDocumentStatus = {}));
